interface TruckWithBoxAndComputerSVGProps {
  color: string;
  style: React.CSSProperties;
}

const TruckWithBoxAndComputerSVG = ({
  color,
  style,
}: TruckWithBoxAndComputerSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="50"
    viewBox="0 0 48 50"
    fill="none"
  >
    <g clipPath="url(#clip0_678_13213)">
      <path
        d="M23.1709 29.1289L30.1179 25.116L37.0749 29.1289L30.1179 33.1418"
        stroke={color}
        strokeWidth="1.12926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.0749 29.1289V37.1547L30.1179 41.1676L23.1709 37.1547V29.1289"
        stroke={color}
        strokeWidth="1.12926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.1172 33.1417V38.4755"
        stroke={color}
        strokeWidth="1.12926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.2956 19.9435H45.3224C46.4214 19.9435 47.3087 20.8308 47.3087 21.9298V43.4866C47.3087 44.5856 46.4214 45.4729 45.3224 45.4729H14.913C13.814 45.4729 12.9268 44.5856 12.9268 43.4866V21.9298C12.9268 20.8308 13.814 19.9435 14.913 19.9435H27.7281"
        stroke={color}
        strokeWidth="1.12926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.8889 45.4829L40.4517 49.4353H30.117H19.7822L21.345 45.4829"
        stroke={color}
        strokeWidth="1.12926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.7393 4.1944C34.2416 4.51704 35.6733 5.26316 36.8328 6.42267C37.9923 7.58218 38.7385 9.01392 39.0611 10.5162"
        stroke={color}
        strokeWidth="1.12926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.1318 0.564636C35.4004 1.05869 37.5581 2.17786 39.3226 3.94233C41.0871 5.7068 42.2062 7.8645 42.7003 10.1331"
        stroke={color}
        strokeWidth="1.12926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.8701 7.81409C33.4852 7.94516 34.0599 8.24764 34.5338 8.72153C35.0076 9.19541 35.3101 9.78021 35.4412 10.3852"
        stroke={color}
        strokeWidth="1.12926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.1172 16.5154V23.291"
        stroke={color}
        strokeWidth="1.12926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2818 17.3825C17.917 16.8381 18.4413 16.1625 18.7942 15.3963L27.314 14.5997C27.8686 15.5777 28.9273 16.2432 30.1372 16.2432C31.9319 16.2432 33.3838 14.7913 33.3838 12.9966C33.3838 11.2019 31.9319 9.74996 30.1372 9.74996C28.9273 9.74996 27.8686 10.4154 27.314 11.3934L18.7942 10.5969C17.8867 8.6207 15.8904 7.24945 13.5713 7.24945C10.3953 7.24945 7.82422 9.82053 7.82422 12.9966C7.82422 15.4568 9.36687 17.5539 11.5346 18.3706"
        stroke={color}
        strokeWidth="1.12926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0807 24.6824H0.564453V1.31073H11.0807C12.462 1.31073 13.5711 2.42991 13.5711 3.80115V7.24943"
        stroke={color}
        strokeWidth="1.12926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5712 15.4164C12.2403 15.4164 11.1514 14.3376 11.1514 12.9966C11.1514 11.6556 12.2302 10.5767 13.5712 10.5767"
        stroke={color}
        strokeWidth="1.12926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_678_13213">
        <rect width="47.8826" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default TruckWithBoxAndComputerSVG;
